module.exports = __webpack_public_path__ + "static/media/trashIcon.fff44be7.png";